import { jobTypeKey } from '@/utils/jobType';

/**
 * Shared helpers for rendering a partner-facing job/offer title — used by both
 * the offers list row (OfferInList.vue) and the offer detail view (Offer.vue)
 * so the two can't drift. See GID-2544.
 */
export default {
  methods: {
    // Translated job-type label (e.g. "Installation"), or '' when none applies.
    jobTypeLabel(offer) {
      const key = jobTypeKey(offer);
      return key ? this.$t(`job.typeString.${key}`) : '';
    },
    // Customer city from the shipping address, or '' when unavailable.
    jobCustomerCity(offer) {
      if (offer && offer.customer && offer.customer.shipping_address) {
        return offer.customer.shipping_address.city || '';
      }
      return '';
    },
    // Brand in-app logo URL (brand_assets.for_apps, projected by gid-api as
    // brand.for_apps), or null when the brand has no uploaded logo.
    jobBrandLogo(offer) {
      if (offer && offer.brand) {
        return offer.brand.for_apps || null;
      }
      return null;
    },
  },
};
